export interface INewErrorCode  {
    // Идентификаторы кода
    searchCode: string;
    oemCode?: string;           // "10", "3A", "P0201", "BF", "144" – как в мануале
    hexCode?: string;           // если отдельно указано hex (из ZF-таблиц)
    spn?: number;               // J1939 SPN
    fmi?: number;               // J1939 FMI
    sa?: number;                // Source Address (если есть)
    j1939FaultCode?: number;    // Cummins-like "Fault code" номер (если отдельно)
    manufacturer?: string;      // "ZF", "ISUZU HCM", "Caterpillar", etc.
    system?: string;            // "Transmission", "Engine", "TCU", "ECM"

    // Текстовые описания
    title?: string;             // Короткий заголовок: "LOGICAL ERROR AT GEAR RANGE SIGNAL"
    description?: string;       // Развёрнутое "Meaning of the fault code" / Reason summary
    possibleReasons?: string[]; // Список причин ("cable from shift lever to TCU is broken" и т.п.)
    effectsWhileActive?: string[]; // "Reaction of the TCU", "Effect only when fault code is active"
    repairSteps?: string[];     // "Possible steps to repair" / "Check ..."
    notes?: string[];           // Разное: "Some fault codes are not applied to this machine", OEM‑комменты

    // Контекст применения
    modelFamilies?: string[];   // "6WG", "4WG", "Sisu", "John Deere", "Case", и пр.
    controlUnit?: string;       // "TCU", "ECM", "EEC controller" – что генерирует код
    canPgn?: number;            // если из описания можно вытащить PGN (для CAN-сообщений)
    severity?: "info" | "warning" | "derate" | "shutdown" | "limp-home" | "no-reaction" | "maintenance" | "unknown";
    activeOnlyEffects?: boolean;// true, если эффект "only when fault code is active"

    // Источник данных (PDF)
    source: {
        fileId: string;           // ID pdf в твоём хранилище
        fileName?: string;        // оригинальное имя
        page?: number;            // страница
        tableId?: string;         // логический ID таблички, если будешь размечать
        rawSnippet?: string;      // сырой фрагмент текста, из которого это распарсили
    };

    // Техническое
    locale?: "en" | "ru" | string; // язык описаний
    tempId?: string;
}

export interface IErrorCode extends INewErrorCode {
    id: string;
    created_at: string;
    updated_at: string;
}

export const emptyErrorCode: INewErrorCode = {
    searchCode: "",
    oemCode: '',
    hexCode: '',
    spn: undefined,
    fmi: undefined,
    sa: undefined,
    j1939FaultCode: undefined,
    manufacturer: '',
    system: '',
    title: '',
    description: '',
    possibleReasons: [],
    effectsWhileActive: [],
    repairSteps: [],
    notes: [],
    modelFamilies: [],
    controlUnit: '',
    canPgn: undefined,
    severity: 'unknown',
    activeOnlyEffects: false,
    source: {
        fileId: '',
        fileName: '',
        page: undefined,
        tableId: '',
        rawSnippet: '',
    },
    locale: 'en',
    tempId: "first",
};

export const defaultErrorCode: IErrorCode = {
    ...emptyErrorCode,
    id: 'some id',
    created_at: "",
    updated_at: "",
}